/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, viewChild } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipDirective, TooltipModule } from 'ngx-bootstrap/tooltip';

import { MarkSearchStringPipe } from '@bn/shared/core/pipes';

import { BadgeComponent } from '../../../../badge/badge.component';
import { FlagComponent } from '../../../../flag/flag.component';
import { IndicatorSelectTemplateComponent } from '../indicator-select-template/indicator-select-template.component';

@Component({
  selector: 'bn-web-ui-option-select-template',
  templateUrl: './option-select-template.component.html',
  imports: [NgTemplateOutlet, FaIconComponent, FlagComponent, BadgeComponent, IndicatorSelectTemplateComponent, MarkSearchStringPipe, TooltipModule],
  providers: [TooltipDirective],
})
export class OptionSelectTemplateComponent {
  readonly optionTemplate = viewChild.required<TemplateRef<any>>('optionTemplate');
}
